const getters = {
  values: state => state.values,
  rangeDevicesValuesMonth: state => state.rangeDevicesValuesMonth,
  devicesCanSend: state => state.devicesCanSend,
  displayDevices: state => state.displayDevices,
  isLoading: state => state.isLoading
};

export default getters;
